<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="applications-container">
  @for (application of filteredApplications; track application) {
    <div class="col-lg-4 col-md-6 application-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ application.organizationName }}</h5>
          </mat-card-title>
          <mat-card-subtitle>
            <p></p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Natječaj:</strong> {{ application.grantName }}
          </p>
          <p>
            <strong>Organizacija:</strong> {{ application.organizationName }}
          </p>
          <p>
            <strong>Naziv programa/projekta:</strong> {{ application.programProjectName }}
          </p>
          <p>
            <strong>Datum predaje:</strong> {{ application.submittedAt | date: 'd.M.yyyy. HH:mm:ss' }}
          </p>
          <p>
            <strong>Status:</strong>
            <span
              class="daxa-badge"
                    [ngClass]="{
                      'evaluation': application.status === ApplicationStatus.InCompliance
                            || application.status === ApplicationStatus.NonCompliance  
                            || application.status === ApplicationStatus.PositiveReview 
                            || application.status === ApplicationStatus.NegativeReview,
                      'submited': application.status === ApplicationStatus.Submitted,
                      'returned': application.status === ApplicationStatus.Returned,
                      'resubmitted': application.status === ApplicationStatus.Resubmitted,
                      'draft': application.status === ApplicationStatus.Draft,
                      'approved': application.status === ApplicationStatus.Approved,
                      'rejected': application.status === ApplicationStatus.Rejected
                    }"
              >
              {{ application.municipalityFriendlyStatus }}
            </span>
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj prijavu" (click)="goToViewApplication(application)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (application.isActionAllowed('Return')) {
            <button mat-icon-button color="primary" matTooltip="Vrati prijavu na doradu" (click)="confirmReturn(application)">
              <mat-icon>reply</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Preuzmi obrasce" (click)="downloadForms(application, [ApplicationFormType.B1, ApplicationFormType.B2, ApplicationFormType.B3, ApplicationFormType.B6])">
            <mat-icon>download</mat-icon>
          </button>
          @if (application.isActionAllowed('Comply')) {
            <button mat-icon-button color="primary" matTooltip="Provjera ispunjenja formalnih uvjeta" (click)="goToComplyApplication(application)">
              <mat-icon>fact_check</mat-icon>
            </button>
          }
          @if (application.isActionAllowed('Review')) {
            <button mat-icon-button color="primary" matTooltip="Ocijeni prijavu" (click)="goToReviewApplication(application)">
              <mat-icon>rate_review</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Pogledaj recenzije" (click)="goToApplicationReviews(application)">
            <mat-icon>comment</mat-icon>
          </button>
          @if (application.isActionAllowed('CreateProject') && !application.isProjectCreated) {
            <button mat-icon-button color="primary" matTooltip="Kreiraj projekt iz prijave" (click)="goToCreateProject(application)">
              <mat-icon>description</mat-icon>
            </button>
          }
          @if (application.isActionAllowed('Approve')) {
            <button mat-icon-button color="primary" matTooltip="Odobri prijavu" (click)="confirmApprove(application)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (application.isActionAllowed('Reject')) {
            <button mat-icon-button color="warn" matTooltip="Odbij prijavu" (click)="confirmReject(application)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
